<ng-template #searchResults let-r="result" let-t="term">
    <ngb-highlight [result]="r.BLDG+(r.BLDG ? ' ('+r.BUILDING_NAME+ '-' + r.ADDRESS1 + ') ' + r.SITE_NAME  : '')" [term]="t"></ngb-highlight>
</ng-template>

    <input id="{{name}}" name="{{name}}" type="text" [(ngModel)]="value" class="form-control" [ngbTypeahead]="search"
        placeholder="{{placeholder}}" [required]="required" [disabled]="disabled" (ngModelChange)="updateChanges()"
        [resultTemplate]="searchResults" [inputFormatter]="searchInputFormatter" [editable]='false'
        (selectItem)="handleSearchResults($event)" aria-label="search" />